// src/store/actions/actionTypes.js
// Auth action types
export const AUTH_START = 'AUTH_START';
export const REGISTER_START = 'REGISTER_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR';
export const CLEAR_REGISTER_ERROR = 'CLEAR_REGISTER_ERROR';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';

export const AUTH_ACTIONS = {
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGOUT: 'LOGOUT',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  SET_TOKENS: 'SET_TOKENS',
};

export const ENTITY_ACTIONS = {
  // Fetch entities
  FETCH_ENTITIES_REQUEST: 'FETCH_ENTITIES_REQUEST',
  FETCH_ENTITIES_SUCCESS: 'FETCH_ENTITIES_SUCCESS',
  FETCH_ENTITIES_FAILURE: 'FETCH_ENTITIES_FAILURE',

  // Fetch single entity
  FETCH_ENTITY_REQUEST: 'FETCH_ENTITY_REQUEST',
  FETCH_ENTITY_SUCCESS: 'FETCH_ENTITY_SUCCESS',
  FETCH_ENTITY_FAILURE: 'FETCH_ENTITY_FAILURE',

  // Create entity
  CREATE_ENTITY_REQUEST: 'CREATE_ENTITY_REQUEST',
  CREATE_ENTITY_SUCCESS: 'CREATE_ENTITY_SUCCESS',
  CREATE_ENTITY_FAILURE: 'CREATE_ENTITY_FAILURE',

  // Update entity
  UPDATE_ENTITY_REQUEST: 'UPDATE_ENTITY_REQUEST',
  UPDATE_ENTITY_SUCCESS: 'UPDATE_ENTITY_SUCCESS',
  UPDATE_ENTITY_FAILURE: 'UPDATE_ENTITY_FAILURE',

  // Delete entity
  DELETE_ENTITY_REQUEST: 'DELETE_ENTITY_REQUEST',
  DELETE_ENTITY_SUCCESS: 'DELETE_ENTITY_SUCCESS',
  DELETE_ENTITY_FAILURE: 'DELETE_ENTITY_FAILURE',

  // Toggle entity status
  TOGGLE_ENTITY_STATUS_REQUEST: 'TOGGLE_ENTITY_STATUS_REQUEST',
  TOGGLE_ENTITY_STATUS_SUCCESS: 'TOGGLE_ENTITY_STATUS_SUCCESS',
  TOGGLE_ENTITY_STATUS_FAILURE: 'TOGGLE_ENTITY_STATUS_FAILURE',

  // Upload entity image
  UPLOAD_ENTITY_IMAGE_REQUEST: 'UPLOAD_ENTITY_IMAGE_REQUEST',
  UPLOAD_ENTITY_IMAGE_SUCCESS: 'UPLOAD_ENTITY_IMAGE_SUCCESS',
  UPLOAD_ENTITY_IMAGE_FAILURE: 'UPLOAD_ENTITY_IMAGE_FAILURE',

  // Fetch entity products
  FETCH_ENTITY_PRODUCTS_REQUEST: 'FETCH_ENTITY_PRODUCTS_REQUEST',
  FETCH_ENTITY_PRODUCTS_SUCCESS: 'FETCH_ENTITY_PRODUCTS_SUCCESS',
  FETCH_ENTITY_PRODUCTS_FAILURE: 'FETCH_ENTITY_PRODUCTS_FAILURE',

  // Fetch entity agencies
  FETCH_ENTITY_AGENCIES_REQUEST: 'FETCH_ENTITY_AGENCIES_REQUEST',
  FETCH_ENTITY_AGENCIES_SUCCESS: 'FETCH_ENTITY_AGENCIES_SUCCESS',
  FETCH_ENTITY_AGENCIES_FAILURE: 'FETCH_ENTITY_AGENCIES_FAILURE',

  // Bulk delete
  BULK_DELETE_ENTITIES_REQUEST: 'BULK_DELETE_ENTITIES_REQUEST',
  BULK_DELETE_ENTITIES_SUCCESS: 'BULK_DELETE_ENTITIES_SUCCESS',
  BULK_DELETE_ENTITIES_FAILURE: 'BULK_DELETE_ENTITIES_FAILURE',

  // Clear states
  CLEAR_ENTITY_ERROR: 'CLEAR_ENTITY_ERROR',
  CLEAR_ENTITY_SUCCESS: 'CLEAR_ENTITY_SUCCESS',
  CLEAR_SELECTED_ENTITY: 'CLEAR_SELECTED_ENTITY',
  SET_ENTITY_FILTERS: 'SET_ENTITY_FILTERS',
};

// User action types
export const USER_FETCH_START = 'USER_FETCH_START';
export const USER_FETCH_SUCCESS = 'USER_FETCH_SUCCESS';
export const USER_FETCH_FAIL = 'USER_FETCH_FAIL';
// ... add more user types as needed

// Product action types
export const PRODUCT_FETCH_START = 'PRODUCT_FETCH_START';
export const PRODUCT_FETCH_SUCCESS = 'PRODUCT_FETCH_SUCCESS';
export const PRODUCT_FETCH_FAIL = 'PRODUCT_FETCH_FAIL';
// ... add more product types as needed

// Document action types
export const DOCUMENT_UPLOAD_START = 'DOCUMENT_UPLOAD_START';
export const DOCUMENT_UPLOAD_SUCCESS = 'DOCUMENT_UPLOAD_SUCCESS';
export const DOCUMENT_UPLOAD_FAIL = 'DOCUMENT_UPLOAD_FAIL';
// ... add more document types as needed

// User Types
export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';

export const TOGGLE_USER_STATUS_REQUEST = 'TOGGLE_USER_STATUS_REQUEST';
export const TOGGLE_USER_STATUS_SUCCESS = 'TOGGLE_USER_STATUS_SUCCESS';
export const TOGGLE_USER_STATUS_FAILURE = 'TOGGLE_USER_STATUS_FAILURE';

export const RESET_USER_PASSWORD_REQUEST = 'RESET_USER_PASSWORD_REQUEST';
export const RESET_USER_PASSWORD_SUCCESS = 'RESET_USER_PASSWORD_SUCCESS';
export const RESET_USER_PASSWORD_FAILURE = 'RESET_USER_PASSWORD_FAILURE';

export const VERIFY_USER_REQUEST = 'VERIFY_USER_REQUEST';
export const VERIFY_USER_SUCCESS = 'VERIFY_USER_SUCCESS';
export const VERIFY_USER_FAILURE = 'VERIFY_USER_FAILURE';

export const ASSIGN_USER_ROLES_REQUEST = 'ASSIGN_USER_ROLES_REQUEST';
export const ASSIGN_USER_ROLES_SUCCESS = 'ASSIGN_USER_ROLES_SUCCESS';
export const ASSIGN_USER_ROLES_FAILURE = 'ASSIGN_USER_ROLES_FAILURE';

export const FETCH_USER_ROLES_REQUEST = 'FETCH_USER_ROLES_REQUEST';
export const FETCH_USER_ROLES_SUCCESS = 'FETCH_USER_ROLES_SUCCESS';
export const FETCH_USER_ROLES_FAILURE = 'FETCH_USER_ROLES_FAILURE';

export const FETCH_USER_ACTIVITY_REQUEST = 'FETCH_USER_ACTIVITY_REQUEST';
export const FETCH_USER_ACTIVITY_SUCCESS = 'FETCH_USER_ACTIVITY_SUCCESS';
export const FETCH_USER_ACTIVITY_FAILURE = 'FETCH_USER_ACTIVITY_FAILURE';

export const FETCH_USER_STATISTICS_REQUEST = 'FETCH_USER_STATISTICS_REQUEST';
export const FETCH_USER_STATISTICS_SUCCESS = 'FETCH_USER_STATISTICS_SUCCESS';
export const FETCH_USER_STATISTICS_FAILURE = 'FETCH_USER_STATISTICS_FAILURE';

export const FETCH_USER_HIERARCHY_REQUEST = 'FETCH_USER_HIERARCHY_REQUEST';
export const FETCH_USER_HIERARCHY_SUCCESS = 'FETCH_USER_HIERARCHY_SUCCESS';
export const FETCH_USER_HIERARCHY_FAILURE = 'FETCH_USER_HIERARCHY_FAILURE';

export const FETCH_ORGANIZATION_CHART_REQUEST = 'FETCH_ORGANIZATION_CHART_REQUEST';
export const FETCH_ORGANIZATION_CHART_SUCCESS = 'FETCH_ORGANIZATION_CHART_SUCCESS';
export const FETCH_ORGANIZATION_CHART_FAILURE = 'FETCH_ORGANIZATION_CHART_FAILURE';

// Role Types
export const FETCH_ROLES_REQUEST = 'FETCH_ROLES_REQUEST';
export const FETCH_ROLES_SUCCESS = 'FETCH_ROLES_SUCCESS';
export const FETCH_ROLES_FAILURE = 'FETCH_ROLES_FAILURE';

export const FETCH_ROLE_REQUEST = 'FETCH_ROLE_REQUEST';
export const FETCH_ROLE_SUCCESS = 'FETCH_ROLE_SUCCESS';
export const FETCH_ROLE_FAILURE = 'FETCH_ROLE_FAILURE';

export const CREATE_ROLE_REQUEST = 'CREATE_ROLE_REQUEST';
export const CREATE_ROLE_SUCCESS = 'CREATE_ROLE_SUCCESS';
export const CREATE_ROLE_FAILURE = 'CREATE_ROLE_FAILURE';

export const UPDATE_ROLE_REQUEST = 'UPDATE_ROLE_REQUEST';
export const UPDATE_ROLE_SUCCESS = 'UPDATE_ROLE_SUCCESS';
export const UPDATE_ROLE_FAILURE = 'UPDATE_ROLE_FAILURE';

export const DELETE_ROLE_REQUEST = 'DELETE_ROLE_REQUEST';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_FAILURE = 'DELETE_ROLE_FAILURE';

export const ASSIGN_PERMISSIONS_TO_ROLE_REQUEST = 'ASSIGN_PERMISSIONS_TO_ROLE_REQUEST';
export const ASSIGN_PERMISSIONS_TO_ROLE_SUCCESS = 'ASSIGN_PERMISSIONS_TO_ROLE_SUCCESS';
export const ASSIGN_PERMISSIONS_TO_ROLE_FAILURE = 'ASSIGN_PERMISSIONS_TO_ROLE_FAILURE';

// Permission Types
export const FETCH_PERMISSIONS_REQUEST = 'FETCH_PERMISSIONS_REQUEST';
export const FETCH_PERMISSIONS_SUCCESS = 'FETCH_PERMISSIONS_SUCCESS';
export const FETCH_PERMISSIONS_FAILURE = 'FETCH_PERMISSIONS_FAILURE';

export const FETCH_PERMISSION_MODULES_REQUEST = 'FETCH_PERMISSION_MODULES_REQUEST';
export const FETCH_PERMISSION_MODULES_SUCCESS = 'FETCH_PERMISSION_MODULES_SUCCESS';
export const FETCH_PERMISSION_MODULES_FAILURE = 'FETCH_PERMISSION_MODULES_FAILURE';

export const CREATE_PERMISSION_REQUEST = 'CREATE_PERMISSION_REQUEST';
export const CREATE_PERMISSION_SUCCESS = 'CREATE_PERMISSION_SUCCESS';
export const CREATE_PERMISSION_FAILURE = 'CREATE_PERMISSION_FAILURE';

export const DELETE_PERMISSION_REQUEST = 'DELETE_PERMISSION_REQUEST';
export const DELETE_PERMISSION_SUCCESS = 'DELETE_PERMISSION_SUCCESS';
export const DELETE_PERMISSION_FAILURE = 'DELETE_PERMISSION_FAILURE';

export const FETCH_PERMISSION_REQUEST = 'FETCH_PERMISSION_REQUEST';
export const FETCH_PERMISSION_SUCCESS = 'FETCH_PERMISSION_SUCCESS';
export const FETCH_PERMISSION_FAILURE = 'FETCH_PERMISSION_FAILURE';

export const UPDATE_PERMISSION_REQUEST = 'UPDATE_PERMISSION_REQUEST';
export const UPDATE_PERMISSION_SUCCESS = 'UPDATE_PERMISSION_SUCCESS';
export const UPDATE_PERMISSION_FAILURE = 'UPDATE_PERMISSION_FAILURE';


// Reference Data Types
export const FETCH_EMPLOYEE_TYPES_REQUEST = 'FETCH_EMPLOYEE_TYPES_REQUEST';
export const FETCH_EMPLOYEE_TYPES_SUCCESS = 'FETCH_EMPLOYEE_TYPES_SUCCESS';
export const FETCH_EMPLOYEE_TYPES_FAILURE = 'FETCH_EMPLOYEE_TYPES_FAILURE';

export const FETCH_EMPLOYMENT_STATUSES_REQUEST = 'FETCH_EMPLOYMENT_STATUSES_REQUEST';
export const FETCH_EMPLOYMENT_STATUSES_SUCCESS = 'FETCH_EMPLOYMENT_STATUSES_SUCCESS';
export const FETCH_EMPLOYMENT_STATUSES_FAILURE = 'FETCH_EMPLOYMENT_STATUSES_FAILURE';

export const FETCH_ACCESS_LEVELS_REQUEST = 'FETCH_ACCESS_LEVELS_REQUEST';
export const FETCH_ACCESS_LEVELS_SUCCESS = 'FETCH_ACCESS_LEVELS_SUCCESS';
export const FETCH_ACCESS_LEVELS_FAILURE = 'FETCH_ACCESS_LEVELS_FAILURE';

export const FETCH_DEPARTMENTS_REQUEST = 'FETCH_DEPARTMENTS_REQUEST';
export const FETCH_DEPARTMENTS_SUCCESS = 'FETCH_DEPARTMENTS_SUCCESS';
export const FETCH_DEPARTMENTS_FAILURE = 'FETCH_DEPARTMENTS_FAILURE';

export const FETCH_TEAMS_REQUEST = 'FETCH_TEAMS_REQUEST';
export const FETCH_TEAMS_SUCCESS = 'FETCH_TEAMS_SUCCESS';
export const FETCH_TEAMS_FAILURE = 'FETCH_TEAMS_FAILURE';

export const FETCH_MANAGERS_REQUEST = 'FETCH_MANAGERS_REQUEST';
export const FETCH_MANAGERS_SUCCESS = 'FETCH_MANAGERS_SUCCESS';
export const FETCH_MANAGERS_FAILURE = 'FETCH_MANAGERS_FAILURE';

export const FETCH_REFERENCE_DATA_REQUEST = 'FETCH_REFERENCE_DATA_REQUEST';
export const FETCH_REFERENCE_DATA_SUCCESS = 'FETCH_REFERENCE_DATA_SUCCESS';
export const FETCH_REFERENCE_DATA_FAILURE = 'FETCH_REFERENCE_DATA_FAILURE';


export const GARAGE_ACTION_TYPES = {
  // Fetch garages
  FETCH_GARAGES_REQUEST: 'FETCH_GARAGES_REQUEST',
  FETCH_GARAGES_SUCCESS: 'FETCH_GARAGES_SUCCESS',
  FETCH_GARAGES_FAIL: 'FETCH_GARAGES_FAIL',
  
  // Fetch single garage
  FETCH_GARAGE_REQUEST: 'FETCH_GARAGE_REQUEST',
  FETCH_GARAGE_SUCCESS: 'FETCH_GARAGE_SUCCESS',
  FETCH_GARAGE_FAIL: 'FETCH_GARAGE_FAIL',

  FETCH_MAKES_REQUEST: 'FETCH_MAKES_REQUEST',
  FETCH_MAKES_SUCCESS: 'FETCH_MAKES_SUCCESS',
  FETCH_MAKES_FAIL: 'FETCH_MAKES_FAIL',
  
  // Create garage
  CREATE_GARAGE_REQUEST: 'CREATE_GARAGE_REQUEST',
  CREATE_GARAGE_SUCCESS: 'CREATE_GARAGE_SUCCESS',
  CREATE_GARAGE_FAIL: 'CREATE_GARAGE_FAIL',
  
  // Update garage
  UPDATE_GARAGE_REQUEST: 'UPDATE_GARAGE_REQUEST',
  UPDATE_GARAGE_SUCCESS: 'UPDATE_GARAGE_SUCCESS',
  UPDATE_GARAGE_FAIL: 'UPDATE_GARAGE_FAIL',
  
  // Delete garage
  DELETE_GARAGE_REQUEST: 'DELETE_GARAGE_REQUEST',
  DELETE_GARAGE_SUCCESS: 'DELETE_GARAGE_SUCCESS',
  DELETE_GARAGE_FAIL: 'DELETE_GARAGE_FAIL',
  
  // Update approval status
  UPDATE_APPROVAL_REQUEST: 'UPDATE_APPROVAL_REQUEST',
  UPDATE_APPROVAL_SUCCESS: 'UPDATE_APPROVAL_SUCCESS',
  UPDATE_APPROVAL_FAIL: 'UPDATE_APPROVAL_FAIL',
  
  // Add review
  ADD_REVIEW_REQUEST: 'ADD_REVIEW_REQUEST',
  ADD_REVIEW_SUCCESS: 'ADD_REVIEW_SUCCESS',
  ADD_REVIEW_FAIL: 'ADD_REVIEW_FAIL',
  
  // Bulk import
  BULK_IMPORT_REQUEST: 'BULK_IMPORT_REQUEST',
  BULK_IMPORT_SUCCESS: 'BULK_IMPORT_SUCCESS',
  BULK_IMPORT_FAIL: 'BULK_IMPORT_FAIL',
  
  // Fetch statistics
  FETCH_STATISTICS_REQUEST: 'FETCH_STATISTICS_REQUEST',
  FETCH_STATISTICS_SUCCESS: 'FETCH_STATISTICS_SUCCESS',
  FETCH_STATISTICS_FAIL: 'FETCH_STATISTICS_FAIL',
  
  // Clear states
  CLEAR_GARAGE_ERROR: 'CLEAR_GARAGE_ERROR',
  CLEAR_GARAGE_SUCCESS: 'CLEAR_GARAGE_SUCCESS',
  CLEAR_GARAGE_STATE: 'CLEAR_GARAGE_STATE',
};

// Garage types enum
export const GARAGE_TYPES = {
  INDEPENDENT: 'INDEPENDENT',
  DEALERSHIP: 'DEALERSHIP',
  CHAIN: 'CHAIN',
  SPECIALIZED: 'SPECIALIZED',
};

// Approval status enum
export const APPROVAL_STATUS = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  SUSPENDED: 'SUSPENDED',
};

// Service types enum
export const SERVICE_TYPES = {
  REPAIR: 'REPAIR',
  MAINTENANCE: 'MAINTENANCE',
  BODY_WORK: 'BODY_WORK',
  TOWING: 'TOWING',
  DIAGNOSTIC: 'DIAGNOSTIC',
};

export const SERVICE_ACTIONS = {
  // Fetch services
  FETCH_SERVICES_REQUEST: 'FETCH_SERVICES_REQUEST',
  FETCH_SERVICES_SUCCESS: 'FETCH_SERVICES_SUCCESS',
  FETCH_SERVICES_FAILURE: 'FETCH_SERVICES_FAILURE',

  // Fetch single service
  FETCH_SERVICE_REQUEST: 'FETCH_SERVICE_REQUEST',
  FETCH_SERVICE_SUCCESS: 'FETCH_SERVICE_SUCCESS',
  FETCH_SERVICE_FAILURE: 'FETCH_SERVICE_FAILURE',

  // Create service
  CREATE_SERVICE_REQUEST: 'CREATE_SERVICE_REQUEST',
  CREATE_SERVICE_SUCCESS: 'CREATE_SERVICE_SUCCESS',
  CREATE_SERVICE_FAILURE: 'CREATE_SERVICE_FAILURE',

  // Update service
  UPDATE_SERVICE_REQUEST: 'UPDATE_SERVICE_REQUEST',
  UPDATE_SERVICE_SUCCESS: 'UPDATE_SERVICE_SUCCESS',
  UPDATE_SERVICE_FAILURE: 'UPDATE_SERVICE_FAILURE',

  // Delete service
  DELETE_SERVICE_REQUEST: 'DELETE_SERVICE_REQUEST',
  DELETE_SERVICE_SUCCESS: 'DELETE_SERVICE_SUCCESS',
  DELETE_SERVICE_FAILURE: 'DELETE_SERVICE_FAILURE',

  // Toggle service status
  TOGGLE_SERVICE_STATUS_REQUEST: 'TOGGLE_SERVICE_STATUS_REQUEST',
  TOGGLE_SERVICE_STATUS_SUCCESS: 'TOGGLE_SERVICE_STATUS_SUCCESS',
  TOGGLE_SERVICE_STATUS_FAILURE: 'TOGGLE_SERVICE_STATUS_FAILURE',

  // Bulk delete
  BULK_DELETE_SERVICES_REQUEST: 'BULK_DELETE_SERVICES_REQUEST',
  BULK_DELETE_SERVICES_SUCCESS: 'BULK_DELETE_SERVICES_SUCCESS',
  BULK_DELETE_SERVICES_FAILURE: 'BULK_DELETE_SERVICES_FAILURE',

  // Fetch service agencies
  FETCH_SERVICE_AGENCIES_REQUEST: 'FETCH_SERVICE_AGENCIES_REQUEST',
  FETCH_SERVICE_AGENCIES_SUCCESS: 'FETCH_SERVICE_AGENCIES_SUCCESS',
  FETCH_SERVICE_AGENCIES_FAILURE: 'FETCH_SERVICE_AGENCIES_FAILURE',
  
  // Fetch popular services
  FETCH_POPULAR_SERVICES_REQUEST: 'FETCH_POPULAR_SERVICES_REQUEST',
  FETCH_POPULAR_SERVICES_SUCCESS: 'FETCH_POPULAR_SERVICES_SUCCESS',
  FETCH_POPULAR_SERVICES_FAILURE: 'FETCH_POPULAR_SERVICES_FAILURE',
  
  // Fetch service statistics
  FETCH_SERVICE_STATS_REQUEST: 'FETCH_SERVICE_STATS_REQUEST',
  FETCH_SERVICE_STATS_SUCCESS: 'FETCH_SERVICE_STATS_SUCCESS',
  FETCH_SERVICE_STATS_FAILURE: 'FETCH_SERVICE_STATS_FAILURE',

  // Clear states
  CLEAR_SERVICE_ERROR: 'CLEAR_SERVICE_ERROR',
  CLEAR_SERVICE_SUCCESS: 'CLEAR_SERVICE_SUCCESS',
  CLEAR_SELECTED_SERVICE: 'CLEAR_SELECTED_SERVICE',
  SET_SERVICE_FILTERS: 'SET_SERVICE_FILTERS',
};


export const AGENCY_ACTIONS = {
  // Fetch agencies
  FETCH_AGENCIES_REQUEST: 'FETCH_AGENCIES_REQUEST',
  FETCH_AGENCIES_SUCCESS: 'FETCH_AGENCIES_SUCCESS',
  FETCH_AGENCIES_FAILURE: 'FETCH_AGENCIES_FAILURE',

  // Fetch single agency
  FETCH_AGENCY_REQUEST: 'FETCH_AGENCY_REQUEST',
  FETCH_AGENCY_SUCCESS: 'FETCH_AGENCY_SUCCESS',
  FETCH_AGENCY_FAILURE: 'FETCH_AGENCY_FAILURE',

  // Create agency
  CREATE_AGENCY_REQUEST: 'CREATE_AGENCY_REQUEST',
  CREATE_AGENCY_SUCCESS: 'CREATE_AGENCY_SUCCESS',
  CREATE_AGENCY_FAILURE: 'CREATE_AGENCY_FAILURE',

  // Update agency
  UPDATE_AGENCY_REQUEST: 'UPDATE_AGENCY_REQUEST',
  UPDATE_AGENCY_SUCCESS: 'UPDATE_AGENCY_SUCCESS',
  UPDATE_AGENCY_FAILURE: 'UPDATE_AGENCY_FAILURE',

  // Delete agency
  DELETE_AGENCY_REQUEST: 'DELETE_AGENCY_REQUEST',
  DELETE_AGENCY_SUCCESS: 'DELETE_AGENCY_SUCCESS',
  DELETE_AGENCY_FAILURE: 'DELETE_AGENCY_FAILURE',

  // Toggle agency status
  TOGGLE_AGENCY_STATUS_REQUEST: 'TOGGLE_AGENCY_STATUS_REQUEST',
  TOGGLE_AGENCY_STATUS_SUCCESS: 'TOGGLE_AGENCY_STATUS_SUCCESS',
  TOGGLE_AGENCY_STATUS_FAILURE: 'TOGGLE_AGENCY_STATUS_FAILURE',

  // Fetch agency services
  FETCH_AGENCY_SERVICES_REQUEST: 'FETCH_AGENCY_SERVICES_REQUEST',
  FETCH_AGENCY_SERVICES_SUCCESS: 'FETCH_AGENCY_SERVICES_SUCCESS',
  FETCH_AGENCY_SERVICES_FAILURE: 'FETCH_AGENCY_SERVICES_FAILURE',

  // Update agency services
  UPDATE_AGENCY_SERVICES_REQUEST: 'UPDATE_AGENCY_SERVICES_REQUEST',
  UPDATE_AGENCY_SERVICES_SUCCESS: 'UPDATE_AGENCY_SERVICES_SUCCESS',
  UPDATE_AGENCY_SERVICES_FAILURE: 'UPDATE_AGENCY_SERVICES_FAILURE',

  // Fetch opening hours
  FETCH_OPENING_HOURS_REQUEST: 'FETCH_OPENING_HOURS_REQUEST',
  FETCH_OPENING_HOURS_SUCCESS: 'FETCH_OPENING_HOURS_SUCCESS',
  FETCH_OPENING_HOURS_FAILURE: 'FETCH_OPENING_HOURS_FAILURE',

  // Update opening hours
  UPDATE_OPENING_HOURS_REQUEST: 'UPDATE_OPENING_HOURS_REQUEST',
  UPDATE_OPENING_HOURS_SUCCESS: 'UPDATE_OPENING_HOURS_SUCCESS',
  UPDATE_OPENING_HOURS_FAILURE: 'UPDATE_OPENING_HOURS_FAILURE',

  // Fetch agency documents
  FETCH_AGENCY_DOCUMENTS_REQUEST: 'FETCH_AGENCY_DOCUMENTS_REQUEST',
  FETCH_AGENCY_DOCUMENTS_SUCCESS: 'FETCH_AGENCY_DOCUMENTS_SUCCESS',
  FETCH_AGENCY_DOCUMENTS_FAILURE: 'FETCH_AGENCY_DOCUMENTS_FAILURE',

  // Upload agency document
  UPLOAD_AGENCY_DOCUMENT_REQUEST: 'UPLOAD_AGENCY_DOCUMENT_REQUEST',
  UPLOAD_AGENCY_DOCUMENT_SUCCESS: 'UPLOAD_AGENCY_DOCUMENT_SUCCESS',
  UPLOAD_AGENCY_DOCUMENT_FAILURE: 'UPLOAD_AGENCY_DOCUMENT_FAILURE',

  // Delete agency document
  DELETE_AGENCY_DOCUMENT_REQUEST: 'DELETE_AGENCY_DOCUMENT_REQUEST',
  DELETE_AGENCY_DOCUMENT_SUCCESS: 'DELETE_AGENCY_DOCUMENT_SUCCESS',
  DELETE_AGENCY_DOCUMENT_FAILURE: 'DELETE_AGENCY_DOCUMENT_FAILURE',

  // Bulk delete
  BULK_DELETE_AGENCIES_REQUEST: 'BULK_DELETE_AGENCIES_REQUEST',
  BULK_DELETE_AGENCIES_SUCCESS: 'BULK_DELETE_AGENCIES_SUCCESS',
  BULK_DELETE_AGENCIES_FAILURE: 'BULK_DELETE_AGENCIES_FAILURE',

  // Clear states
  CLEAR_AGENCY_ERROR: 'CLEAR_AGENCY_ERROR',
  CLEAR_AGENCY_SUCCESS: 'CLEAR_AGENCY_SUCCESS',
  CLEAR_SELECTED_AGENCY: 'CLEAR_SELECTED_AGENCY',
  SET_AGENCY_FILTERS: 'SET_AGENCY_FILTERS',
};


export const ATTESTATION_ACTIONS = {
  // Fetch attestations
  FETCH_ATTESTATIONS_REQUEST: 'FETCH_ATTESTATIONS_REQUEST',
  FETCH_ATTESTATIONS_SUCCESS: 'FETCH_ATTESTATIONS_SUCCESS',
  FETCH_ATTESTATIONS_FAILURE: 'FETCH_ATTESTATIONS_FAILURE',

  // Fetch single attestation
  FETCH_ATTESTATION_REQUEST: 'FETCH_ATTESTATION_REQUEST',
  FETCH_ATTESTATION_SUCCESS: 'FETCH_ATTESTATION_SUCCESS',
  FETCH_ATTESTATION_FAILURE: 'FETCH_ATTESTATION_FAILURE',

  // Create attestation
  CREATE_ATTESTATION_REQUEST: 'CREATE_ATTESTATION_REQUEST',
  CREATE_ATTESTATION_SUCCESS: 'CREATE_ATTESTATION_SUCCESS',
  CREATE_ATTESTATION_FAILURE: 'CREATE_ATTESTATION_FAILURE',

  // Update attestation
  UPDATE_ATTESTATION_REQUEST: 'UPDATE_ATTESTATION_REQUEST',
  UPDATE_ATTESTATION_SUCCESS: 'UPDATE_ATTESTATION_SUCCESS',
  UPDATE_ATTESTATION_FAILURE: 'UPDATE_ATTESTATION_FAILURE',

  // Delete attestation
  DELETE_ATTESTATION_REQUEST: 'DELETE_ATTESTATION_REQUEST',
  DELETE_ATTESTATION_SUCCESS: 'DELETE_ATTESTATION_SUCCESS',
  DELETE_ATTESTATION_FAILURE: 'DELETE_ATTESTATION_FAILURE',

  // Update attestation status
  UPDATE_ATTESTATION_STATUS_REQUEST: 'UPDATE_ATTESTATION_STATUS_REQUEST',
  UPDATE_ATTESTATION_STATUS_SUCCESS: 'UPDATE_ATTESTATION_STATUS_SUCCESS',
  UPDATE_ATTESTATION_STATUS_FAILURE: 'UPDATE_ATTESTATION_STATUS_FAILURE',

  // Sync attestation
  SYNC_ATTESTATION_REQUEST: 'SYNC_ATTESTATION_REQUEST',
  SYNC_ATTESTATION_SUCCESS: 'SYNC_ATTESTATION_SUCCESS',
  SYNC_ATTESTATION_FAILURE: 'SYNC_ATTESTATION_FAILURE',

  // Bulk sync attestations
  BULK_SYNC_ATTESTATIONS_REQUEST: 'BULK_SYNC_ATTESTATIONS_REQUEST',
  BULK_SYNC_ATTESTATIONS_SUCCESS: 'BULK_SYNC_ATTESTATIONS_SUCCESS',
  BULK_SYNC_ATTESTATIONS_FAILURE: 'BULK_SYNC_ATTESTATIONS_FAILURE',

  // Fetch attestation stats
  FETCH_ATTESTATION_STATS_REQUEST: 'FETCH_ATTESTATION_STATS_REQUEST',
  FETCH_ATTESTATION_STATS_SUCCESS: 'FETCH_ATTESTATION_STATS_SUCCESS',
  FETCH_ATTESTATION_STATS_FAILURE: 'FETCH_ATTESTATION_STATS_FAILURE',

  // Fetch attestations by sender
  FETCH_ATTESTATIONS_BY_SENDER_REQUEST: 'FETCH_ATTESTATIONS_BY_SENDER_REQUEST',
  FETCH_ATTESTATIONS_BY_SENDER_SUCCESS: 'FETCH_ATTESTATIONS_BY_SENDER_SUCCESS',
  FETCH_ATTESTATIONS_BY_SENDER_FAILURE: 'FETCH_ATTESTATIONS_BY_SENDER_FAILURE',

  // Fetch attestations by receiver
  FETCH_ATTESTATIONS_BY_RECEIVER_REQUEST: 'FETCH_ATTESTATIONS_BY_RECEIVER_REQUEST',
  FETCH_ATTESTATIONS_BY_RECEIVER_SUCCESS: 'FETCH_ATTESTATIONS_BY_RECEIVER_SUCCESS',
  FETCH_ATTESTATIONS_BY_RECEIVER_FAILURE: 'FETCH_ATTESTATIONS_BY_RECEIVER_FAILURE',

  // Export attestations
  EXPORT_ATTESTATIONS_REQUEST: 'EXPORT_ATTESTATIONS_REQUEST',
  EXPORT_ATTESTATIONS_SUCCESS: 'EXPORT_ATTESTATIONS_SUCCESS',
  EXPORT_ATTESTATIONS_FAILURE: 'EXPORT_ATTESTATIONS_FAILURE',

  // Fetch attestation documents
  FETCH_ATTESTATION_DOCUMENTS_REQUEST: 'FETCH_ATTESTATION_DOCUMENTS_REQUEST',
  FETCH_ATTESTATION_DOCUMENTS_SUCCESS: 'FETCH_ATTESTATION_DOCUMENTS_SUCCESS',
  FETCH_ATTESTATION_DOCUMENTS_FAILURE: 'FETCH_ATTESTATION_DOCUMENTS_FAILURE',

  // Upload attestation document
  UPLOAD_ATTESTATION_DOCUMENT_REQUEST: 'UPLOAD_ATTESTATION_DOCUMENT_REQUEST',
  UPLOAD_ATTESTATION_DOCUMENT_SUCCESS: 'UPLOAD_ATTESTATION_DOCUMENT_SUCCESS',
  UPLOAD_ATTESTATION_DOCUMENT_FAILURE: 'UPLOAD_ATTESTATION_DOCUMENT_FAILURE',

  // Delete attestation document
  DELETE_ATTESTATION_DOCUMENT_REQUEST: 'DELETE_ATTESTATION_DOCUMENT_REQUEST',
  DELETE_ATTESTATION_DOCUMENT_SUCCESS: 'DELETE_ATTESTATION_DOCUMENT_SUCCESS',
  DELETE_ATTESTATION_DOCUMENT_FAILURE: 'DELETE_ATTESTATION_DOCUMENT_FAILURE',

    // Presigned URL upload
  REQUEST_PRESIGNED_UPLOAD_REQUEST: 'REQUEST_PRESIGNED_UPLOAD_REQUEST',
  REQUEST_PRESIGNED_UPLOAD_SUCCESS: 'REQUEST_PRESIGNED_UPLOAD_SUCCESS',
  REQUEST_PRESIGNED_UPLOAD_FAILURE: 'REQUEST_PRESIGNED_UPLOAD_FAILURE',
  
  CONFIRM_DOCUMENT_UPLOAD_REQUEST: 'CONFIRM_DOCUMENT_UPLOAD_REQUEST',
  CONFIRM_DOCUMENT_UPLOAD_SUCCESS: 'CONFIRM_DOCUMENT_UPLOAD_SUCCESS',
  CONFIRM_DOCUMENT_UPLOAD_FAILURE: 'CONFIRM_DOCUMENT_UPLOAD_FAILURE',

  // Clear states
  CLEAR_ATTESTATION_ERROR: 'CLEAR_ATTESTATION_ERROR',
  CLEAR_ATTESTATION_SUCCESS: 'CLEAR_ATTESTATION_SUCCESS',
  CLEAR_SELECTED_ATTESTATION: 'CLEAR_SELECTED_ATTESTATION',
  SET_ATTESTATION_FILTERS: 'SET_ATTESTATION_FILTERS',
  CLEAR_DOCUMENT_ERROR: 'CLEAR_DOCUMENT_ERROR',
  CLEAR_DOCUMENT_SUCCESS: 'CLEAR_DOCUMENT_SUCCESS',
};

// Category Actions
export const CATEGORY_ACTIONS = {
  // Fetch categories
  FETCH_CATEGORIES_REQUEST: 'FETCH_CATEGORIES_REQUEST',
  FETCH_CATEGORIES_SUCCESS: 'FETCH_CATEGORIES_SUCCESS',
  FETCH_CATEGORIES_FAILURE: 'FETCH_CATEGORIES_FAILURE',

  // Fetch single category
  FETCH_CATEGORY_REQUEST: 'FETCH_CATEGORY_REQUEST',
  FETCH_CATEGORY_SUCCESS: 'FETCH_CATEGORY_SUCCESS',
  FETCH_CATEGORY_FAILURE: 'FETCH_CATEGORY_FAILURE',

  // Create category
  CREATE_CATEGORY_REQUEST: 'CREATE_CATEGORY_REQUEST',
  CREATE_CATEGORY_SUCCESS: 'CREATE_CATEGORY_SUCCESS',
  CREATE_CATEGORY_FAILURE: 'CREATE_CATEGORY_FAILURE',

  // Update category
  UPDATE_CATEGORY_REQUEST: 'UPDATE_CATEGORY_REQUEST',
  UPDATE_CATEGORY_SUCCESS: 'UPDATE_CATEGORY_SUCCESS',
  UPDATE_CATEGORY_FAILURE: 'UPDATE_CATEGORY_FAILURE',

  // Delete category
  DELETE_CATEGORY_REQUEST: 'DELETE_CATEGORY_REQUEST',
  DELETE_CATEGORY_SUCCESS: 'DELETE_CATEGORY_SUCCESS',
  DELETE_CATEGORY_FAILURE: 'DELETE_CATEGORY_FAILURE',

  //fetch category stats
  FETCH_CATEGORY_STATS_REQUEST: 'FETCH_CATEGORY_STATS_REQUEST',
  FETCH_CATEGORY_STATS_SUCCESS: 'FETCH_CATEGORY_STATS_SUCCESS',
  FETCH_CATEGORY_STATS_FAILURE: 'FETCH_CATEGORY_STATS_FAILURE',

  // fetch category tree
  FETCH_CATEGORY_TREE_REQUEST: 'FETCH_CATEGORY_TREE_REQUEST',
  FETCH_CATEGORY_TREE_SUCCESS: 'FETCH_CATEGORY_TREE_SUCCESS',
  FETCH_CATEGORY_TREE_FAILURE: 'FETCH_CATEGORY_TREE_FAILURE',

  // Bulk delete categories
  BULK_DELETE_CATEGORIES_REQUEST: 'BULK_DELETE_CATEGORIES_REQUEST',
  BULK_DELETE_CATEGORIES_SUCCESS: 'BULK_DELETE_CATEGORIES_SUCCESS',
  BULK_DELETE_CATEGORIES_FAILURE: 'BULK_DELETE_CATEGORIES_FAILURE',

  // Clear states
  CLEAR_CATEGORY_ERROR: 'CLEAR_CATEGORY_ERROR',
  CLEAR_CATEGORY_SUCCESS: 'CLEAR_CATEGORY_SUCCESS',
  CLEAR_SELECTED_CATEGORY: 'CLEAR_SELECTED_CATEGORY',
  SET_CATEGORY_FILTERS: 'SET_CATEGORY_FILTERS',
};

// Tag Actions
export const TAG_ACTIONS = {
  // Fetch tags
  FETCH_TAGS_REQUEST: 'FETCH_TAGS_REQUEST',
  FETCH_TAGS_SUCCESS: 'FETCH_TAGS_SUCCESS',
  FETCH_TAGS_FAILURE: 'FETCH_TAGS_FAILURE',

  // Fetch single tag
  FETCH_TAG_REQUEST: 'FETCH_TAG_REQUEST',
  FETCH_TAG_SUCCESS: 'FETCH_TAG_SUCCESS',
  FETCH_TAG_FAILURE: 'FETCH_TAG_FAILURE',

  // Create tag
  CREATE_TAG_REQUEST: 'CREATE_TAG_REQUEST',
  CREATE_TAG_SUCCESS: 'CREATE_TAG_SUCCESS',
  CREATE_TAG_FAILURE: 'CREATE_TAG_FAILURE',

  // Update tag
  UPDATE_TAG_REQUEST: 'UPDATE_TAG_REQUEST',
  UPDATE_TAG_SUCCESS: 'UPDATE_TAG_SUCCESS',
  UPDATE_TAG_FAILURE: 'UPDATE_TAG_FAILURE',

  // Delete tag
  DELETE_TAG_REQUEST: 'DELETE_TAG_REQUEST',
  DELETE_TAG_SUCCESS: 'DELETE_TAG_SUCCESS',
  DELETE_TAG_FAILURE: 'DELETE_TAG_FAILURE',

  // Bulk delete tags
  BULK_DELETE_TAGS_REQUEST: 'BULK_DELETE_TAGS_REQUEST',
  BULK_DELETE_TAGS_SUCCESS: 'BULK_DELETE_TAGS_SUCCESS',
  BULK_DELETE_TAGS_FAILURE: 'BULK_DELETE_TAGS_FAILURE',

  // Fetch tag stats
  FETCH_TAG_STATS_REQUEST: 'FETCH_TAG_STATS_REQUEST',
  FETCH_TAG_STATS_SUCCESS: 'FETCH_TAG_STATS_SUCCESS',
  FETCH_TAG_STATS_FAILURE: 'FETCH_TAG_STATS_FAILURE',

  // Fetch popular tags
  FETCH_POPULAR_TAGS_REQUEST: 'FETCH_POPULAR_TAGS_REQUEST',
  FETCH_POPULAR_TAGS_SUCCESS: 'FETCH_POPULAR_TAGS_SUCCESS',
  FETCH_POPULAR_TAGS_FAILURE: 'FETCH_POPULAR_TAGS_FAILURE',

  //merge tags
  MERGE_TAGS_REQUEST: 'MERGE_TAGS_REQUEST',
  MERGE_TAGS_SUCCESS: 'MERGE_TAGS_SUCCESS',
  MERGE_TAGS_FAILURE: 'MERGE_TAGS_FAILURE',

  // Clear states
  CLEAR_TAG_ERROR: 'CLEAR_TAG_ERROR',
  CLEAR_TAG_SUCCESS: 'CLEAR_TAG_SUCCESS',
  CLEAR_SELECTED_TAG: 'CLEAR_SELECTED_TAG',
  SET_TAG_FILTERS: 'SET_TAG_FILTERS',
};

export const BLOG_POST_ACTIONS = {
  // Fetch blog posts
  FETCH_BLOG_POSTS_REQUEST: 'FETCH_BLOG_POSTS_REQUEST',
  FETCH_BLOG_POSTS_SUCCESS: 'FETCH_BLOG_POSTS_SUCCESS',
  FETCH_BLOG_POSTS_FAILURE: 'FETCH_BLOG_POSTS_FAILURE',

  // Fetch single blog post
  FETCH_BLOG_POST_REQUEST: 'FETCH_BLOG_POST_REQUEST',
  FETCH_BLOG_POST_SUCCESS: 'FETCH_BLOG_POST_SUCCESS',
  FETCH_BLOG_POST_FAILURE: 'FETCH_BLOG_POST_FAILURE',

  // Create blog post
  CREATE_BLOG_POST_REQUEST: 'CREATE_BLOG_POST_REQUEST',
  CREATE_BLOG_POST_SUCCESS: 'CREATE_BLOG_POST_SUCCESS',
  CREATE_BLOG_POST_FAILURE: 'CREATE_BLOG_POST_FAILURE',

  // Update blog post
  UPDATE_BLOG_POST_REQUEST: 'UPDATE_BLOG_POST_REQUEST',
  UPDATE_BLOG_POST_SUCCESS: 'UPDATE_BLOG_POST_SUCCESS',
  UPDATE_BLOG_POST_FAILURE: 'UPDATE_BLOG_POST_FAILURE',

  // Delete blog post
  DELETE_BLOG_POST_REQUEST: 'DELETE_BLOG_POST_REQUEST',
  DELETE_BLOG_POST_SUCCESS: 'DELETE_BLOG_POST_SUCCESS',
  DELETE_BLOG_POST_FAILURE: 'DELETE_BLOG_POST_FAILURE',

  // Update blog post status
  UPDATE_BLOG_POST_STATUS_REQUEST: 'UPDATE_BLOG_POST_STATUS_REQUEST',
  UPDATE_BLOG_POST_STATUS_SUCCESS: 'UPDATE_BLOG_POST_STATUS_SUCCESS',
  UPDATE_BLOG_POST_STATUS_FAILURE: 'UPDATE_BLOG_POST_STATUS_FAILURE',

  // Fetch blog comments
  FETCH_BLOG_COMMENTS_REQUEST: 'FETCH_BLOG_COMMENTS_REQUEST',
  FETCH_BLOG_COMMENTS_SUCCESS: 'FETCH_BLOG_COMMENTS_SUCCESS',
  FETCH_BLOG_COMMENTS_FAILURE: 'FETCH_BLOG_COMMENTS_FAILURE',

  // Update comment status
  UPDATE_COMMENT_STATUS_REQUEST: 'UPDATE_COMMENT_STATUS_REQUEST',
  UPDATE_COMMENT_STATUS_SUCCESS: 'UPDATE_COMMENT_STATUS_SUCCESS',
  UPDATE_COMMENT_STATUS_FAILURE: 'UPDATE_COMMENT_STATUS_FAILURE',

  // Delete comment
  DELETE_COMMENT_REQUEST: 'DELETE_COMMENT_REQUEST',
  DELETE_COMMENT_SUCCESS: 'DELETE_COMMENT_SUCCESS',
  DELETE_COMMENT_FAILURE: 'DELETE_COMMENT_FAILURE',

  // Fetch categories
  FETCH_BLOG_CATEGORIES_REQUEST: 'FETCH_BLOG_CATEGORIES_REQUEST',
  FETCH_BLOG_CATEGORIES_SUCCESS: 'FETCH_BLOG_CATEGORIES_SUCCESS',
  FETCH_BLOG_CATEGORIES_FAILURE: 'FETCH_BLOG_CATEGORIES_FAILURE',

  // Fetch tags
  FETCH_BLOG_TAGS_REQUEST: 'FETCH_BLOG_TAGS_REQUEST',
  FETCH_BLOG_TAGS_SUCCESS: 'FETCH_BLOG_TAGS_SUCCESS',
  FETCH_BLOG_TAGS_FAILURE: 'FETCH_BLOG_TAGS_FAILURE',

  // Upload featured image
  UPLOAD_FEATURED_IMAGE_REQUEST: 'UPLOAD_FEATURED_IMAGE_REQUEST',
  UPLOAD_FEATURED_IMAGE_SUCCESS: 'UPLOAD_FEATURED_IMAGE_SUCCESS',
  UPLOAD_FEATURED_IMAGE_FAILURE: 'UPLOAD_FEATURED_IMAGE_FAILURE',

  //fetch blog post stats
  FETCH_BLOG_STATS_REQUEST: 'FETCH_BLOG_STATS_REQUEST',
  FETCH_BLOG_STATS_SUCCESS: 'FETCH_BLOG_STATS_SUCCESS',
  FETCH_BLOG_STATS_FAILURE: 'FETCH_BLOG_STATS_FAILURE',

  // Bulk delete blog posts
  BULK_DELETE_BLOG_POSTS_REQUEST: 'BULK_DELETE_BLOG_POSTS_REQUEST',
  BULK_DELETE_BLOG_POSTS_SUCCESS: 'BULK_DELETE_BLOG_POSTS_SUCCESS',
  BULK_DELETE_BLOG_POSTS_FAILURE: 'BULK_DELETE_BLOG_POSTS_FAILURE',

  //delete blogpost document
  DELETE_DOCUMENT_REQUEST: 'DELETE_DOCUMENT_REQUEST',
  DELETE_DOCUMENT_SUCCESS: 'DELETE_DOCUMENT_SUCCESS',
  DELETE_DOCUMENT_FAILURE: 'DELETE_DOCUMENT_FAILURE',

  // Clear states
  CLEAR_BLOG_POST_ERROR: 'CLEAR_BLOG_POST_ERROR',
  CLEAR_BLOG_POST_SUCCESS: 'CLEAR_BLOG_POST_SUCCESS',
  CLEAR_SELECTED_BLOG_POST: 'CLEAR_SELECTED_BLOG_POST',
  SET_BLOG_POST_FILTERS: 'SET_BLOG_POST_FILTERS',
};


export const FAQ_ACTIONS = {
  // Fetch FAQs
  FETCH_FAQS_REQUEST: 'FETCH_FAQS_REQUEST',
  FETCH_FAQS_SUCCESS: 'FETCH_FAQS_SUCCESS',
  FETCH_FAQS_FAILURE: 'FETCH_FAQS_FAILURE',

  // Fetch single FAQ
  FETCH_FAQ_REQUEST: 'FETCH_FAQ_REQUEST',
  FETCH_FAQ_SUCCESS: 'FETCH_FAQ_SUCCESS',
  FETCH_FAQ_FAILURE: 'FETCH_FAQ_FAILURE',

  // Create FAQ
  CREATE_FAQ_REQUEST: 'CREATE_FAQ_REQUEST',
  CREATE_FAQ_SUCCESS: 'CREATE_FAQ_SUCCESS',
  CREATE_FAQ_FAILURE: 'CREATE_FAQ_FAILURE',

  // Update FAQ
  UPDATE_FAQ_REQUEST: 'UPDATE_FAQ_REQUEST',
  UPDATE_FAQ_SUCCESS: 'UPDATE_FAQ_SUCCESS',
  UPDATE_FAQ_FAILURE: 'UPDATE_FAQ_FAILURE',

  // Delete FAQ
  DELETE_FAQ_REQUEST: 'DELETE_FAQ_REQUEST',
  DELETE_FAQ_SUCCESS: 'DELETE_FAQ_SUCCESS',
  DELETE_FAQ_FAILURE: 'DELETE_FAQ_FAILURE',

  // Update FAQ status
  UPDATE_FAQ_STATUS_REQUEST: 'UPDATE_FAQ_STATUS_REQUEST',
  UPDATE_FAQ_STATUS_SUCCESS: 'UPDATE_FAQ_STATUS_SUCCESS',
  UPDATE_FAQ_STATUS_FAILURE: 'UPDATE_FAQ_STATUS_FAILURE',

  // Fetch FAQ feedback
  FETCH_FAQ_FEEDBACK_REQUEST: 'FETCH_FAQ_FEEDBACK_REQUEST',
  FETCH_FAQ_FEEDBACK_SUCCESS: 'FETCH_FAQ_FEEDBACK_SUCCESS',
  FETCH_FAQ_FEEDBACK_FAILURE: 'FETCH_FAQ_FEEDBACK_FAILURE',

  // Fetch related FAQs
  FETCH_RELATED_FAQS_REQUEST: 'FETCH_RELATED_FAQS_REQUEST',
  FETCH_RELATED_FAQS_SUCCESS: 'FETCH_RELATED_FAQS_SUCCESS',
  FETCH_RELATED_FAQS_FAILURE: 'FETCH_RELATED_FAQS_FAILURE',

  // Add related FAQ
  ADD_RELATED_FAQ_REQUEST: 'ADD_RELATED_FAQ_REQUEST',
  ADD_RELATED_FAQ_SUCCESS: 'ADD_RELATED_FAQ_SUCCESS',
  ADD_RELATED_FAQ_FAILURE: 'ADD_RELATED_FAQ_FAILURE',

  // Remove related FAQ
  REMOVE_RELATED_FAQ_REQUEST: 'REMOVE_RELATED_FAQ_REQUEST',
  REMOVE_RELATED_FAQ_SUCCESS: 'REMOVE_RELATED_FAQ_SUCCESS',
  REMOVE_RELATED_FAQ_FAILURE: 'REMOVE_RELATED_FAQ_FAILURE',

  // Upload FAQ image
  UPLOAD_FAQ_IMAGE_REQUEST: 'UPLOAD_FAQ_IMAGE_REQUEST',
  UPLOAD_FAQ_IMAGE_SUCCESS: 'UPLOAD_FAQ_IMAGE_SUCCESS',
  UPLOAD_FAQ_IMAGE_FAILURE: 'UPLOAD_FAQ_IMAGE_FAILURE',

  // Delete FAQ image
  DELETE_FAQ_IMAGE_REQUEST: 'DELETE_FAQ_IMAGE_REQUEST',
  DELETE_FAQ_IMAGE_SUCCESS: 'DELETE_FAQ_IMAGE_SUCCESS',
  DELETE_FAQ_IMAGE_FAILURE: 'DELETE_FAQ_IMAGE_FAILURE',

  // Fetch FAQ categories
  FETCH_FAQ_CATEGORIES_REQUEST: 'FETCH_FAQ_CATEGORIES_REQUEST',
  FETCH_FAQ_CATEGORIES_SUCCESS: 'FETCH_FAQ_CATEGORIES_SUCCESS',
  FETCH_FAQ_CATEGORIES_FAILURE: 'FETCH_FAQ_CATEGORIES_FAILURE',

  // Fetch FAQ tags
  FETCH_FAQ_TAGS_REQUEST: 'FETCH_FAQ_TAGS_REQUEST',
  FETCH_FAQ_TAGS_SUCCESS: 'FETCH_FAQ_TAGS_SUCCESS',
  FETCH_FAQ_TAGS_FAILURE: 'FETCH_FAQ_TAGS_FAILURE',

  //delete faq document
  DELETE_DOCUMENT_REQUEST: 'DELETE_DOCUMENT_REQUEST',
  DELETE_DOCUMENT_SUCCESS: 'DELETE_DOCUMENT_SUCCESS',
  DELETE_DOCUMENT_FAILURE: 'DELETE_DOCUMENT_FAILURE',

  //bulk delete
  BULK_DELETE_FAQS_FAILURE: 'BULK_DELETE_FAQS_FAILURE',
  BULK_DELETE_FAQS_SUCCESS: 'BULK_DELETE_FAQS_SUCCESS',
  BULK_DELETE_FAQS_REQUEST: 'BULK_DELETE_FAQS_REQUEST',

  // Clear states
  CLEAR_FAQ_ERROR: 'CLEAR_FAQ_ERROR',
  CLEAR_FAQ_SUCCESS: 'CLEAR_FAQ_SUCCESS',
  CLEAR_SELECTED_FAQ: 'CLEAR_SELECTED_FAQ',
  SET_FAQ_FILTERS: 'SET_FAQ_FILTERS',
};

export const PRODUCT_ACTIONS = {
  // Fetch products
  FETCH_PRODUCTS_REQUEST: 'FETCH_PRODUCTS_REQUEST',
  FETCH_PRODUCTS_SUCCESS: 'FETCH_PRODUCTS_SUCCESS',
  FETCH_PRODUCTS_FAILURE: 'FETCH_PRODUCTS_FAILURE',

  // Fetch single product
  FETCH_PRODUCT_REQUEST: 'FETCH_PRODUCT_REQUEST',
  FETCH_PRODUCT_SUCCESS: 'FETCH_PRODUCT_SUCCESS',
  FETCH_PRODUCT_FAILURE: 'FETCH_PRODUCT_FAILURE',

  // Create product
  CREATE_PRODUCT_REQUEST: 'CREATE_PRODUCT_REQUEST',
  CREATE_PRODUCT_SUCCESS: 'CREATE_PRODUCT_SUCCESS',
  CREATE_PRODUCT_FAILURE: 'CREATE_PRODUCT_FAILURE',

  // Update product
  UPDATE_PRODUCT_REQUEST: 'UPDATE_PRODUCT_REQUEST',
  UPDATE_PRODUCT_SUCCESS: 'UPDATE_PRODUCT_SUCCESS',
  UPDATE_PRODUCT_FAILURE: 'UPDATE_PRODUCT_FAILURE',

  // Delete product
  DELETE_PRODUCT_REQUEST: 'DELETE_PRODUCT_REQUEST',
  DELETE_PRODUCT_SUCCESS: 'DELETE_PRODUCT_SUCCESS',
  DELETE_PRODUCT_FAILURE: 'DELETE_PRODUCT_FAILURE',

  // Toggle product status
  TOGGLE_PRODUCT_STATUS_REQUEST: 'TOGGLE_PRODUCT_STATUS_REQUEST',
  TOGGLE_PRODUCT_STATUS_SUCCESS: 'TOGGLE_PRODUCT_STATUS_SUCCESS',
  TOGGLE_PRODUCT_STATUS_FAILURE: 'TOGGLE_PRODUCT_STATUS_FAILURE',

  // Product features
  ADD_FEATURE_REQUEST: 'ADD_FEATURE_REQUEST',
  ADD_FEATURE_SUCCESS: 'ADD_FEATURE_SUCCESS',
  ADD_FEATURE_FAILURE: 'ADD_FEATURE_FAILURE',
  
  UPDATE_FEATURE_REQUEST: 'UPDATE_FEATURE_REQUEST',
  UPDATE_FEATURE_SUCCESS: 'UPDATE_FEATURE_SUCCESS',
  UPDATE_FEATURE_FAILURE: 'UPDATE_FEATURE_FAILURE',
  
  DELETE_FEATURE_REQUEST: 'DELETE_FEATURE_REQUEST',
  DELETE_FEATURE_SUCCESS: 'DELETE_FEATURE_SUCCESS',
  DELETE_FEATURE_FAILURE: 'DELETE_FEATURE_FAILURE',

  // Product benefits
  ADD_BENEFIT_REQUEST: 'ADD_BENEFIT_REQUEST',
  ADD_BENEFIT_SUCCESS: 'ADD_BENEFIT_SUCCESS',
  ADD_BENEFIT_FAILURE: 'ADD_BENEFIT_FAILURE',
  
  UPDATE_BENEFIT_REQUEST: 'UPDATE_BENEFIT_REQUEST',
  UPDATE_BENEFIT_SUCCESS: 'UPDATE_BENEFIT_SUCCESS',
  UPDATE_BENEFIT_FAILURE: 'UPDATE_BENEFIT_FAILURE',
  
  DELETE_BENEFIT_REQUEST: 'DELETE_BENEFIT_REQUEST',
  DELETE_BENEFIT_SUCCESS: 'DELETE_BENEFIT_SUCCESS',
  DELETE_BENEFIT_FAILURE: 'DELETE_BENEFIT_FAILURE',

  // Product sections
  ADD_SECTION_REQUEST: 'ADD_SECTION_REQUEST',
  ADD_SECTION_SUCCESS: 'ADD_SECTION_SUCCESS',
  ADD_SECTION_FAILURE: 'ADD_SECTION_FAILURE',
  
  UPDATE_SECTION_REQUEST: 'UPDATE_SECTION_REQUEST',
  UPDATE_SECTION_SUCCESS: 'UPDATE_SECTION_SUCCESS',
  UPDATE_SECTION_FAILURE: 'UPDATE_SECTION_FAILURE',
  
  DELETE_SECTION_REQUEST: 'DELETE_SECTION_REQUEST',
  DELETE_SECTION_SUCCESS: 'DELETE_SECTION_SUCCESS',
  DELETE_SECTION_FAILURE: 'DELETE_SECTION_FAILURE',

  // Product Q&A
  ADD_QA_REQUEST: 'ADD_QA_REQUEST',
  ADD_QA_SUCCESS: 'ADD_QA_SUCCESS',
  ADD_QA_FAILURE: 'ADD_QA_FAILURE',
  
  UPDATE_QA_REQUEST: 'UPDATE_QA_REQUEST',
  UPDATE_QA_SUCCESS: 'UPDATE_QA_SUCCESS',
  UPDATE_QA_FAILURE: 'UPDATE_QA_FAILURE',
  
  DELETE_QA_REQUEST: 'DELETE_QA_REQUEST',
  DELETE_QA_SUCCESS: 'DELETE_QA_SUCCESS',
  DELETE_QA_FAILURE: 'DELETE_QA_FAILURE',

  // Pricing tiers
  ADD_PRICING_TIER_REQUEST: 'ADD_PRICING_TIER_REQUEST',
  ADD_PRICING_TIER_SUCCESS: 'ADD_PRICING_TIER_SUCCESS',
  ADD_PRICING_TIER_FAILURE: 'ADD_PRICING_TIER_FAILURE',
  
  UPDATE_PRICING_TIER_REQUEST: 'UPDATE_PRICING_TIER_REQUEST',
  UPDATE_PRICING_TIER_SUCCESS: 'UPDATE_PRICING_TIER_SUCCESS',
  UPDATE_PRICING_TIER_FAILURE: 'UPDATE_PRICING_TIER_FAILURE',
  
  DELETE_PRICING_TIER_REQUEST: 'DELETE_PRICING_TIER_REQUEST',
  DELETE_PRICING_TIER_SUCCESS: 'DELETE_PRICING_TIER_SUCCESS',
  DELETE_PRICING_TIER_FAILURE: 'DELETE_PRICING_TIER_FAILURE',

  // Eligibility criteria
  ADD_ELIGIBILITY_REQUEST: 'ADD_ELIGIBILITY_REQUEST',
  ADD_ELIGIBILITY_SUCCESS: 'ADD_ELIGIBILITY_SUCCESS',
  ADD_ELIGIBILITY_FAILURE: 'ADD_ELIGIBILITY_FAILURE',
  
  UPDATE_ELIGIBILITY_REQUEST: 'UPDATE_ELIGIBILITY_REQUEST',
  UPDATE_ELIGIBILITY_SUCCESS: 'UPDATE_ELIGIBILITY_SUCCESS',
  UPDATE_ELIGIBILITY_FAILURE: 'UPDATE_ELIGIBILITY_FAILURE',
  
  DELETE_ELIGIBILITY_REQUEST: 'DELETE_ELIGIBILITY_REQUEST',
  DELETE_ELIGIBILITY_SUCCESS: 'DELETE_ELIGIBILITY_SUCCESS',
  DELETE_ELIGIBILITY_FAILURE: 'DELETE_ELIGIBILITY_FAILURE',

  // Exclusions
  ADD_EXCLUSION_REQUEST: 'ADD_EXCLUSION_REQUEST',
  ADD_EXCLUSION_SUCCESS: 'ADD_EXCLUSION_SUCCESS',
  ADD_EXCLUSION_FAILURE: 'ADD_EXCLUSION_FAILURE',
  
  UPDATE_EXCLUSION_REQUEST: 'UPDATE_EXCLUSION_REQUEST',
  UPDATE_EXCLUSION_SUCCESS: 'UPDATE_EXCLUSION_SUCCESS',
  UPDATE_EXCLUSION_FAILURE: 'UPDATE_EXCLUSION_FAILURE',
  
  DELETE_EXCLUSION_REQUEST: 'DELETE_EXCLUSION_REQUEST',
  DELETE_EXCLUSION_SUCCESS: 'DELETE_EXCLUSION_SUCCESS',
  DELETE_EXCLUSION_FAILURE: 'DELETE_EXCLUSION_FAILURE',

  // Fetch product documents
  FETCH_PRODUCT_DOCUMENTS_REQUEST: 'FETCH_PRODUCT_DOCUMENTS_REQUEST',
  FETCH_PRODUCT_DOCUMENTS_SUCCESS: 'FETCH_PRODUCT_DOCUMENTS_SUCCESS',
  FETCH_PRODUCT_DOCUMENTS_FAILURE: 'FETCH_PRODUCT_DOCUMENTS_FAILURE',

  // Upload product document
  UPLOAD_PRODUCT_DOCUMENT_REQUEST: 'UPLOAD_PRODUCT_DOCUMENT_REQUEST',
  UPLOAD_PRODUCT_DOCUMENT_SUCCESS: 'UPLOAD_PRODUCT_DOCUMENT_SUCCESS',
  UPLOAD_PRODUCT_DOCUMENT_FAILURE: 'UPLOAD_PRODUCT_DOCUMENT_FAILURE',

  // Delete product document
  DELETE_PRODUCT_DOCUMENT_REQUEST: 'DELETE_PRODUCT_DOCUMENT_REQUEST',
  DELETE_PRODUCT_DOCUMENT_SUCCESS: 'DELETE_PRODUCT_DOCUMENT_SUCCESS',
  DELETE_PRODUCT_DOCUMENT_FAILURE: 'DELETE_PRODUCT_DOCUMENT_FAILURE',

  // Fetch entities
  FETCH_ENTITIES_REQUEST: 'FETCH_ENTITIES_REQUEST',
  FETCH_ENTITIES_SUCCESS: 'FETCH_ENTITIES_SUCCESS',
  FETCH_ENTITIES_FAILURE: 'FETCH_ENTITIES_FAILURE',

  // Bulk delete
  BULK_DELETE_PRODUCTS_REQUEST: 'BULK_DELETE_PRODUCTS_REQUEST',
  BULK_DELETE_PRODUCTS_SUCCESS: 'BULK_DELETE_PRODUCTS_SUCCESS',
  BULK_DELETE_PRODUCTS_FAILURE: 'BULK_DELETE_PRODUCTS_FAILURE',

  // Clear states
  CLEAR_PRODUCT_ERROR: 'CLEAR_PRODUCT_ERROR',
  CLEAR_PRODUCT_SUCCESS: 'CLEAR_PRODUCT_SUCCESS',
  CLEAR_SELECTED_PRODUCT: 'CLEAR_SELECTED_PRODUCT',
  SET_PRODUCT_FILTERS: 'SET_PRODUCT_FILTERS',
};
// UI Types
export const SET_FILTERS = 'SET_FILTERS';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const SET_PAGINATION = 'SET_PAGINATION';
export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';
export const SET_LOADING = 'SET_LOADING';
export const CLEAR_USER_SUCCESS = 'CLEAR_USER_SUCCESS';
export const CLEAR_USER_ERROR = 'CLEAR_USER_ERROR';
export const CLEAR_ROLE_SUCCESS = 'CLEAR_ROLE_SUCCESS';
export const CLEAR_ROLE_ERROR = 'CLEAR_ROLE_ERROR';
export const CLEAR_PERMISSION_SUCCESS = 'CLEAR_PERMISSION_SUCCESS';
export const CLEAR_PERMISSION_ERROR = 'CLEAR_PERMISSION_ERROR';